import { useQueryClient } from "@tanstack/react-query";
import { logout } from "features/slices/authSlice";
import { resetReservationFlow } from "features/slices/reservationFlowSlice";
import { resetTenantState } from "features/slices/tenantSlice";
import { resetTheme } from "features/slices/themeSlice";
import { Platform } from "react-native";
import { useAppDispatch } from "./useAppDispatch";
import authServices from "services/auth.services";
import { resetBuyFlow } from "features/slices/buyFlowSlice";

export const useLogout = () => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  function logoutAccount() {
    resetState();
    dispatch(logout());
    authServices.logout();
    queryClient.removeQueries();
  }

  function resetState() {
    if (Platform.OS !== "web") {
      dispatch(resetTenantState());
      dispatch(resetTheme());
    }
    dispatch(resetReservationFlow());
    dispatch(resetBuyFlow());
  }

  return { logoutAccount, resetState };
};
